import React from 'react';
import { Shield } from 'lucide-react';
import { QUALITY_LABELS } from '../utils/facilityUtils';

interface QualityBadgeProps {
  quality: string;
  showDetails?: boolean;
}

export function QualityBadge({ quality, showDetails = false }: QualityBadgeProps) {
  const label = QUALITY_LABELS[quality];

  return (
    <div className="relative group">
      <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full ${label.color} text-gray-900`}>
        <span className="text-lg">{label.icon}</span>
        <span className="font-medium">{label.name}</span>
        {showDetails && (
          <Shield className="w-4 h-4" />
        )}
      </div>
      
      {showDetails && (
        <div className="absolute left-0 top-full mt-2 w-64 p-4 bg-white rounded-lg shadow-lg border border-gray-100 hidden group-hover:block z-10">
          <p className="text-sm text-gray-600">{label.description}</p>
        </div>
      )}
    </div>
  );
}